export const referral = {
    title: "Parrainez vos collègues",
    none: {
        text: "Pour parrainer vos collègues, vous devez au préalable être {0}.",
        'link-label': "abonné",
        'link-title': "Veuillez vous abonner pour activer le parrainage."
    },
    help1: {
        text: "Vous pouvez parrainer un utilisateur d'Osteo2ls en lui communiquant votre code parrain, ci-dessous. Il bénéficiera de {0}.",
        strong: "50 % de réduction sur son abonnement la première année"
    },
    help2: {
		text: "Dès que votre filleul finalisera son abonnement annuel, vous obtiendrez {0}. Chaque point peut être converti en mois gratuits sur votre abonnement en cours, ce qui repousse sa date de fin.",
		strong: "1 point"
	},
    'default-share-text': "Bénéficiez de 50 % de réduction pendant 1 an (soit 144 € économisés) sur l'abonnement premium annuel Osteo2ls grâce au code : {code}. Inscrivez-vous directement via ce lien https://app.osteo2ls.com/login/register/{code} ou renseignez ce code lors de votre achat.",
    'share-by': "partager par",
    'share-by-email': {
        label: "email",
        title: "Partager par email",
        'action-title': "Parrainez un collègue",
        'action-label': "parrainer"
    },
    'share-by-facebook': {
        label: "facebook",
        title: "Partager par facebook"
    },
    'share-by-twitter': {
        label: "twitter",
        title: "Partager par twitter"
    },
    'referral-code': "Code parrain",
    'referral-url': "Url de parrainage",
	'referral-points-available-at': 'Vous avez atteint le nombre maximal de points convertibles pour une année. Vos points de parrainage restants seront utilisables à partir du {referral_at}.',
    point: "Aucun point | {count} point | {count} points",
    boni: "Boni disponibles",
    header: {
        bonus: "Bonus",
        get: "Obtenir"
    },
    get: "Dépenser {point} pour obtenir {gift}",
    'current-total': "Vous totalisez actuellement",
	'send-referral': {
        title: "Envoyez la facture par email",
        label: "Envoyer la facture",
        succeeded: "Votre parrainage a bien été envoyé à l'adresse <strong>{email}</strong>.",
        failed: "Votre parrainage n'a pu être envoyé à l'adresse <strong>{email}</strong>."
    },
    'apply-gift': {
        additional: "supplémentaire|supplémentaire|supplémentaires",
        success: "Félicitations ! Votre compte vient d'être mis à jour : {gift} {additional}.",
        'default-error': "Une erreur s'est produite, veuillez réessayer plus tard.",
        'not-enough-error': "Vous ne totalisez pas un nombre suffisant de point pour ce cadeau.",
        'no-gift-error': "Aucun cadeau ne semble correspondre à votre demande.",
    },
	'convert-point': {
		'button-title':'Convertir mes points',
		'button-label':'convertir mes points',
		'action-title':'Convertir',
		'action-label':'convertir',
		'popin-title':'Convertir mes points de parrainage',
		succeeded:'Votre abonnement a été prolongé de {months} mois gratuits et votre nouvelle date de fin de licence est à jour',
		failed:'Une erreur s’est produite lors de la tentative de conversion de vos points en mois gratuits.',
		blocked:'En raison de la mise en place de la facturation électronique (réforme RFE), l’utilisation de vos points de parrainage est temporairement suspendue. Vous les retrouverez et pourrez les convertir prochainement.'
	}
}
